import { PrintButton } from '@components/Buttons/PrintButton';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { useValidation } from '@hooks/useValidation';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import { useCaixaCombo } from '@model/Caixa';
import { ICaixaFilter, ICaixaItemRecord, useCaixaService } from '@services/CaixaService';
import { currentCompetence } from '@utils/Functions';
import { yup } from '@validations/Yup';
import React from 'react';
import { CaixaFilter } from './CaixaFilter';
import { CaixaTable } from './CaixaTable';

export type CaixaProps = {
}

export function Caixa (props: CaixaProps) {
    const data = useData<ICaixaItemRecord, ICaixaFilter>({
        filter: {
            caixaId: useField(),
            competencia: useField(currentCompetence()),
        },
    })

    const loading = useLoading();
    const message = useMessage();
    const caixaService = useCaixaService();
    const faturaDetalheModal = useModalWindow();

    const caixaCombo = useCaixaCombo();

    const validation = useValidation<ICaixaFilter>({
        caixaId: yup.number().required(),
        competencia: yup.string().required()
    })

    const handlePrint = React.useCallback(() => {
        const { caixaId, competencia } = data.filter.fields;

        if (caixaId.value !== undefined && competencia.value !== undefined) {
            const mes = Number(competencia.value.substring(2)) - 1;
            const ano = Number(competencia.value.substring(0, 2)) + 2000;

            const periodoDe = new Date(ano, mes, 1);
            const periodoAte = new Date(ano, mes + 1, 0);

            console.log({
                periodoDe, periodoAte
            })

            window.open(`/ImprimirCaixa/${caixaId.value}/${periodoDe}/${periodoAte}`);
        }
    }, [data.filter.fields]);

    React.useEffect(() => {
        const caixaId = data.filter.fields.caixaId.getInputValue();

        if (!loading.isLoading && caixaId !== undefined) {
            const values = data.filter.getInputValues();

            data.filter.clearErrors();

            validation.validate(values)
                .then(() => {
                    loading.start();
                    caixaService.listar(values)
                        .then(data.handleDataResponse)
                        .catch(e => {
                            message.handleResponse(e)
                                .badRequest(data.filter.setErrorsFromServer)
                                .showException();
                        })
                        .finally(loading.stop);
                })
                .catch(data.filter.setErrorsFromYup);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        caixaCombo.loadOptions();
    });

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Caixas" />
                    </GridItem>
                    <GridItem floatRight>
                        <PrintButton onClick={handlePrint} />
                    </GridItem>
                </HorizontalGrid>
            </PageTitle>

            <PageContent>
                <CaixaFilter
                    filter={data.filter}
                    isLoading={loading.isLoading}
                    caixaCombo={caixaCombo}
                />
                
                <TableWrapper>
                    <CaixaTable 
                        data={data}
                        isLoading={loading.isLoading}
                        faturaDetalheModal={faturaDetalheModal}
                    />
                </TableWrapper>
            </PageContent>

            {
                data.focusedRow && data.focusedRow.faturaId !== undefined && (
                    <FaturaDetalheModal 
                        faturaId={data.focusedRow.faturaId}
                        modal={faturaDetalheModal}
                    />
                )
            }
        </Main>
    )
}